import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import WriteForm from '@calendar/components/Write/WriteForm.vue'
import { AlarmModal, StartDateModal, EndDateModal, FolderModal, MeetingRoomModal, StartTimeModal, EndTimeModal } from '../components/Modals'
import * as dateutil from '@/util/date-helper'
import api from '@calendar/api'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as types from '@calendar/store/types'
import * as accountTypes from '@account/store/types'
import * as orgTypes from '@orgmap/store/types'
import { createEventBus, removeEventBus } from '@/util'

@Component({
    components: { 
        WriteForm,
        AlarmModal,
        StartDateModal,
        EndDateModal, 
        FolderModal, 
        MeetingRoomModal, 
        StartTimeModal,
        EndTimeModal
    },
    computed: {
        ...mapGetters({
            User: accountTypes.USER,
            errorMessage: types.COMMON_ERROR_MESSAGE,
            currentItem: types.CURRENT_CALENDAR_ITEM,
            currentRecurring: types.CALENDAR_CURRENT_RECURRING
        })
    },
    methods: {
        ...mapActions({
            add: types.CALENDAR_EVENT_ADD,
        }),
        ...mapMutations({
            addCalendar: types.CALENDAR_EVENT_ADD,
            messageClear: types.COMMON_ERROR_CLEAR,
            setErrorMessage: types.COMMON_ERROR_MESSAGE,
            userListClear: orgTypes.ORG_USER_SELECT_CLEAR
        }),
    },
})
export default class WriteContainer extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User
    errorMessage!: string
    currentItem!: calendar.CalendarItem
    currentRecurring!: calendar.CalendarItemRecurrence

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    add!: () => Promise<boolean>
    
    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    addCalendar!: (value: calendar.CalendarItemContainer) => void
    messageClear!: () => void
    setErrorMessage!: (value: string) => void
    userListClear!: () => void
    
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    email: mail.WriteEmailData = ({
        subject: '',
        to: [],
        cc: [],
        bcc: [],
        body: '',
        attachments: '',
        isBigfile: false,
        code: '',
        codeValues: [],
        importance: 'Normal',
        security: 'Normal',
        whenToSend: '',
    } as unknown) as mail.WriteEmailData

    item: calendar.CalendarItem = {
        parentId: '',
        hasAttachments: false,
        body: '',
        location: '',
        subject: '',
        status: 'S0',
        appointmentType: 'Single',
        pidLidRecurrenceType: 1,
        ui_resourceArray: [] as Array<any>,
        resourceId: null,
        resources: [] as Array<any>,
        recurrence: {} as calendar.CalendarItemRecurrence,
        code: '',
        codeValues: [] as string[],
        importance: 'Normal',
        isCancelled: false,
        isRecurring: false,
        isAllDayEvent: false,
        isAllowUpdate: true,
        start: dateutil.uGetDateFormat('yyyy-MM-dd', new Date()),
        end: dateutil.uGetDateFormat('yyyy-MM-dd', new Date()),
        starttime: '',
        endtime: '',
        requiredAttendees: [] as any,
        optionalAttendees: [] as any,
        isReadyData: false,
        reminderMinutesBeforeStart: 15,
    } as calendar.CalendarItem

    folderName: string = ''

    showStartDateModal: boolean = false
    showEndDateModal: boolean = false
    showStartTimeModal: boolean = false
    showEndTimeModal: boolean = false
    showMeetingRoomModal: boolean = false
    showFolderModal: boolean = false
    showAlarmModal: boolean = false

    // 회의실 자원예약
    selectConference: any | null = null
    addCalendarId: string = '' // 추가된 일정 ID 값

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //유효성검사 오류메세지 출력
    @Watch('errorMessage')
    async onErrorMessageChanged(value: string) {
        if (value) {
            await(window as any).alertAsync(value)
            this.setErrorMessage('')
        }
    }

    setStartTime(time: string) {
        this.item.starttime = time
        this.showStartTimeModal = false
    }

    setEndTime(time: string) {
        this.item.endtime = time
        this.showEndTimeModal = false
    }

    setFolder(folder: any) {
        this.item.parentId = folder.id
        this.folderName = folder.displayName
        this.showFolderModal = false
    }

    setMeetingRoom(room: any) {
        //this.item.resources = [{name: room.text, address: room.value}];
        //this.item.location = room.text
        this.selectConference = room
    }

    setReminder(number: number) {
        this.item.reminderMinutesBeforeStart = number;
        this.showAlarmModal = false;
    }

    showModal(value: string) {
        eval('this.$data.' + value + ' = true')
    }

    //참석자 태그
    convertTagToRec(list?: any[]) {
        return (
            list?.map((r) => ({
                name: r.text,
                address: r.value,
                deptName: r.displayDeptName,
                personCode: r.personCode,
            })) || []
        )
    }

    async save() {
        if (!this.item.parentId) {
            await(window as any).alertAsync(this.$t('M_Mail_PleaseSelectFolder').toString())
            return false
        }
        const invoke = async () => {
            const newItem = {
                ...this.item,
            } as calendar.CalendarItem
            newItem.recurrence = this.item.recurrence
            // 저장할 때 DateFormat 오류 나서 추가
            newItem.start = newItem.start.split('T')[0]
            newItem.end = newItem.end.split('T')[0]
      
            if ((window as any).currentEditor) {
                newItem.body = (window as any).currentEditor.getContent()
            }
      
            if (newItem) {
                if (
                    !newItem.isEWS &&
                    newItem.appointmentType != 'Occurrence' &&
                    newItem.appointmentType != 'Exception' &&
                    newItem.recurrence.ui_useRecurring
                ) {
                    newItem.appointmentType = 'RecurringMaster'
                }
      
                if (newItem.isAllDayEvent) {
                    newItem.starttime = '00:00:00'
                    newItem.endtime = '00:00:00'
        
                    // '하루종일' 체크했을 때 만약 start와 end날짜가 같다면 end날짜를 +1시켜준다
                    let eDate = dateutil.IEDate(newItem.end)
                    eDate.setDate(eDate.getDate() + 1)
                    // this.item.end = eDate.toISOString().slice(0, 10)
                    newItem.end = dateutil.uGetDateFormat('yyyy-MM-DD', eDate)
                }
      
                newItem.organizer = {
                    name: this.User.displayName,
                    address: this.User.email,
                }
                ;(newItem as any).personCode = this.User.personCode
      
                if (isNaN(Number(newItem.parentId))) {
                    newItem.isEWS = true
                }
      
                if (newItem.recurrence && newItem.recurrence.startDate) {
                    newItem.recurrence.startDate = dateutil.DateAndTimeSplitor(
                        newItem.recurrence.startDate
                    )[0]
                }
      
                if (newItem.recurrence && newItem.recurrence.endDate) {
                    newItem.recurrence.endDate = dateutil.DateAndTimeSplitor(newItem.recurrence.endDate)[0]
                }
      
                // newItem.requiredAttendees = this.convertTagToRec(newItem.requiredAttendees);
                // newItem.optionalAttendees = this.convertTagToRec(newItem.optionalAttendees);
      
                newItem.requiredAttendees = this.convertTagToRec(this.email.to)
                newItem.optionalAttendees = this.convertTagToRec(this.email.cc)

                // 회의실 예약하는 경우 유효성 체크 -> 일정 등록  -> 자원예약 등록
                if (this.selectConference) {

                    if (newItem.recurrence.ui_useRecurring) {
                        await(window as any).alertAsync( this.$t("회의실_예약시에는_반복일정을_사용할_수_없습니다").toString())
              
                        return false
                    }

                    if (newItem.requiredAttendees.length == 0) {
                        await(window as any).alertAsync( this.$t("필수_참석자는_1명이상_지정되어야_합니다").toString())
                         
                        return false
                    }

                    let startDate = newItem.start.split('T')[0]
                    let startTime = newItem.starttime
                    let endDate = newItem.end.split('T')[0]
                    let endTime = newItem.endtime

                    //종일인경우 체크해야됨
                    if (newItem.isAllDayEvent == true) {
                        //종일 옵션이 체크된 경우 값 변경 해야됨
                        //시작시작은 00:00:00 으로 
                        //종료시간은 23:59:59 로
                        startTime = "00:00:00"
                        endDate = startDate
                        endTime = "23:59:59"
                    }

                    api.db_resourceReserve.validationReserveRequestIncludeWait({
                        reserveRequestId: null,//this.requestInfo?.reserveRequestId,
                        reserveResourceId: <number>this.selectConference?.resourceId,
                        startDatetime: new Date(`${startDate}T${startTime}`),
                        endDatetime: new Date(`${endDate}T${endTime}`),
                        recurringOption: null//recurringOption ? recurringOption : null
                    }).then(async result => {
                        if (result == false) {
                            await(window as any).alertAsync('선택하신 시간에는 이미 예약되어 있습니다.')
                            return false
                        } else {
                            this.addCalendar({ item: newItem })
                            this.add().then((res) => {
                                if (res) {
                                    //this.$router.push({ path: '/calendar/main' })
                                    this.reserveSave()
                                }
                            })
                        }
                    })
                } else {
                    this.addCalendar({ item: newItem })
                    return this.add().then((res) => {
                        if (res) {
                            this.$router.push({ path: '/calendar/main' })
                        }
                    })
                }
            }
        }
        
        //this.loading(true)
        try {
            await invoke()
            this.userListClear()
        } catch (err) {
            console.error(err)
        }
        //this.loading(false)
    }

    // 회의실 예약
    reserveSave() {
        // //에디터 content 입력
        // this.reserveContent = this.item.body
        // let options = this.currentReccuringOption
        // debugger
        // return
        // //예약 시작 유효청 체크
        // //시작일시는 종료일시보다 크거나 같을 수 없음
        // if (this.valueValidation() == false) {
        //     this.contentLoaded = true
        //     return
        // }

        const newItem = {
            ...this.item,
        } as calendar.CalendarItem

        let startDate = newItem.start.split('T')[0]
        let startTime = newItem.starttime
        let endDate = newItem.end.split('T')[0]
        let endTime = newItem.endtime

        // let isRecursive = false
        // let recurringOption: reservedb.RequestRequestOption | null = null
        // //반복설정 
        // //반복설정이 된 경우
        // if (this.currentReccuringOption != null) {

        //     isRecursive = true

        //     //weekArray 가 타입이 다름 
        //     //database 에 row 로 입력되기 때문에 sperator(",") 추가해서 입력해야됨
        //     //string[] 로 변경해서 전달
        //     let weekArray = ""
        //     if (this.currentReccuringOption.daysOfTheWeekArray &&
        //         this.currentReccuringOption.daysOfTheWeekArray.length > 0) {
        //         const lastItem = this.currentReccuringOption.daysOfTheWeekArray[this.currentReccuringOption.daysOfTheWeekArray.length - 1]
        //         this.currentReccuringOption.daysOfTheWeekArray.forEach(week => {

        //             //마지막 아이템인 경우 , sperator 생략
        //             weekArray += week.toString() + (week == lastItem ? "" : ",")
        //         })
        //     }

        //     recurringOption = {
        //         recuringType: <ReserveRecuringType>this.currentReccuringOption.ui_recurringType,
        //         recuringEndType: <ReserveRecuringEndType>parseInt(this.currentReccuringOption.ui_endType),
        //         recuringStartDate: this.currentReccuringOption.startDate,
        //         recuringEndDate: this.currentReccuringOption.endDate,
        //         recuringInterval: this.currentReccuringOption.interval,
        //         recuringCount: this.currentReccuringOption.numberOfOccurrences,
        //         recuringDayOfMonth: this.currentReccuringOption.dayOfMonth,
        //         recuringDayOfWeekArray: weekArray,
        //         recuringMonth: this.currentReccuringOption.monthValue
        //     }

        // }

        //종일인경우 체크해야됨
        if (newItem.isAllDayEvent == true) {
            //종일 옵션이 체크된 경우 값 변경 해야됨
            //시작시작은 00:00:00 으로 
            //종료시간은 23:59:59 로
            startTime = "00:00:00"
            endDate = startDate
            endTime = "23:59:59"
        }

        var requiredAttendees = this.convertTagToRec(this.email.to)
        var optionalAttendees = this.convertTagToRec(this.email.cc)

        console.log('requiredAttendees', requiredAttendees)

        let requestTargets = requiredAttendees.map((item: any) => {
            let isDepartment = false
            if (item.name == item.deptName) isDepartment = true

            return {
                personCode: item.personCode,
                isOptional: false,
                isDepartment: isDepartment
            }
        })

        let requestOptionalTargets = optionalAttendees.map((item: any) => {
            let isDepartment = false
            if (item.name == item.deptName) isDepartment = true

            return {
                personCode: item.personCode,
                isOptional: true,
                isDepartment: isDepartment
            }
        })

        const resName =  this.selectConference?.displayName

        let inputData = {
            recursiveDescription: null,//this.recurrenceDesc + "\n" + this.recurrenceIntervalDesc,
            reserveResourceId: this.selectConference?.resourceId,
            title: this.item.subject,
            body: this.item.body,
            fileCode: this.item.hasAttachments ? this.item.code : '', //this.files.length > 0 ? this.uploaderConfig.code : "",
            isRecursive: false, //this.item.isRecurring,
            startDate: startDate,
            startTime: startTime,
            endDate: endDate,
            endTime: endTime,
            requestPersonCode: this.User.personCode,
            isCancel: false,
            approvalStatus: 0,
            option: null, //recurringOption,
            targets: [...requestTargets, ...requestOptionalTargets],
            resourceName : resName
        } as any

        // //업데이트의 경우 requestId 추가
        // if (this.requestInfo != null) {
        //   if (this.requestInfo.reserveRequestId) {
        //       inputData.reserveRequestId = this.requestInfo.reserveRequestId
        //   }

        //   //반복일정 중 단건 처리 시 필요 param
        //   var openQueryVal = this.$route.query.open
        //   if (this.requestInfo.isRecursive == true && this.isOccurrence == true) {
        //       inputData.bookingId = parseInt(<string>this.$route.query.bookingId)
        //       inputData.isOccurrence = true
        //   }

        // }

        api.db_resourceReserve.createReserveRequest(inputData).then(result => {
            var requestId = result
            console.log('result', result)
            if (requestId > 0) {

                var data = {
                    reserveRequestId: requestId,
                    reserveResourceId: this.selectConference?.resourceId,
                    calendarItemId: this.addCalendarId
                }
                api.db_resourceReserve.createReserveRequestCalendarMap(data).then(async result => {
                    if (result) {
                        let msg = this.$t("자원예약이_등록되었습니다").toString()
                    
                        if (this.selectConference?.useApproval) {
                            //결재 사용 자원인경우 등록 할 때 메세지 추가 처리
                            
                            msg += `\n${this.$t("자원예약_승인_이후에_자원이_예약됩니다").toString()}`
                        }
                        await(window as any).alertAsync(msg)
                    } else {
                        await(window as any).alertAsync( this.$t("자원예약_등록이_실패하였습니다").toString())
                    }

                    this.$router.push({ path: '/calendar/main' })
                })
            }
        }).finally(() => {
        
        })

    }

    load() {
        let calcDate = new Date()
        calcDate.setMinutes(calcDate.getMinutes() + 30)
        let event: calendar.CalendarItem = {
            start: dateutil.uGetDateFormat('yyyy-MM-DDTH:00:00', calcDate),
            end: dateutil.uGetDateFormat('yyyy-MM-DDTH:30:00', calcDate),
            isAllDayEvent: false,
            //parentId: this.currentFolder?.id,
            // isEWS: this.currentFolder ? this.currentFolder.isEWS : true,
        } as calendar.CalendarItem

        let _target = 'MY'//this.target || this.$route.query.target
        let _pitem = event

        let citem = {} as calendar.CalendarItem

        Object.assign(citem, this.item)

        if (_pitem) {
            let obj: calendar.CalendarItem = _pitem
            citem = {
                ...citem,
                ...obj,
            } as calendar.CalendarItem
        }

        // if (this.$route.query.fid) {
        //     citem.parentId = this.replaceAll(this.$route.query.fid as string, ' ', '+')
        // }

        if (citem.start && (citem.start.indexOf(' ') != -1 || citem.start.indexOf('T') != -1)) {
            citem.starttime = dateutil.DateAndTimeSplitor(citem.start)[1]
        }

        if (citem.end && (citem.end.indexOf(' ') != -1 || citem.end.indexOf('T') != -1)) {
            citem.endtime = dateutil.DateAndTimeSplitor(citem.end)[1]
        }

        if (typeof citem.isAllDayEvent === 'string') {
            citem.isAllDayEvent = (citem.isAllDayEvent as any) === 'True' ? true : false
            // 하루종일 일정일 경우 end에서 하루를 빼줘야 함
            if (citem.isAllDayEvent) {
                let eDate = dateutil.IEDate(citem.end)
                eDate.setDate(eDate.getDate() - 1)
                citem.end = dateutil.uGetDateFormat('yyyy-MM-DD', eDate)
            }
        }
        citem.recurrence.startDate = citem.start + ''
        citem.recurrence.endDate = dateutil.uGetDateFormat(
            'yyyy-MM-DD',
            dateutil.uGetDate(90, dateutil.IEDate(citem.start))
        )

        switch (citem.appointmentType) {
            case 'Single':
                citem.recurrence.ui_useRecurringButton = true
                citem.recurrence.ui_useDefaultDate = true
                citem.recurrence.ui_useRecurringDisplay = false
                citem.recurrence.ui_useRecurring = false
                break
            case 'RecurringMaster':
                citem.recurrence.ui_useRecurringButton = true
                citem.recurrence.ui_useDefaultDate = false
                citem.recurrence.ui_useRecurringDisplay = true
                citem.recurrence.ui_useRecurring = true
                break
            case 'Occurrence':
            case 'Exception':
                citem.recurrence.ui_useRecurringButton = false
                citem.recurrence.ui_useDefaultDate = true
                citem.recurrence.ui_useRecurringDisplay = true
                citem.recurrence.ui_useRecurring = true
                break
                defualt: citem.recurrence.ui_useRecurringButton = true
                citem.recurrence.ui_useDefaultDate = true
                citem.recurrence.ui_useRecurringDisplay = false
                citem.recurrence.ui_useRecurring = false
                break
        }

        this.item = {
            ...this.item,
            ...citem,
        }

        const uid = `uid-${Date.now()}`
        this.item.code = `CALENDAR_${this.User.id}_${uid}`
        this.item.codeValues = [this.User.comCode, 'Calendar', this.User.email, uid]

        //this.target -> _target으로 수정함
        if (_target == 'MY' || _target == 'SHARE') {
            api.ews_resource.getRooms().then((res: Array<any>) => {
                this.item.ui_resourceArray = [
                    { text: 'None', value: null },
                    ...res
                        .filter((x) => x.depth == 1)
                        .map((x) => {
                        return { text: x.name, value: x.address }
                        }),
                ]
                this.item.isReadyData = true
                //this.loading(false)
            })
        } else {
            api.db_resource.getFindCalendarResource({ Type: 'RM' }).then((res) => {
                this.item.ui_resourceArray = [
                    { text: 'None', value: null },
                    ...res.map((x) => {
                        return { text: x.displayName, value: x.id }
                    }),
                ]
                this.item.isReadyData = true
                //this.loading(false)
            })
        }
            
        if(this.$route.query.pvalue) {
            let _occitem = this.$route.query.pvalue as string;
           
            if(_occitem){
                this.item = JSON.parse(decodeURIComponent(_occitem)) as calendar.CalendarItem;
            }
        }
    }

    cancel() {
        this.userListClear()
        this.$router.push({ path: '/calendar/main' })
    }

    getAddCalendarId(id: string) {
        this.addCalendarId = id
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        createEventBus(window, 'calendar-close', this.cancel)
        createEventBus(window, 'calendar-add-result', this.getAddCalendarId)

        this.item.start = dateutil.DateAndTimeSplitor(this.item.start)[0]
        this.item.end = dateutil.DateAndTimeSplitor(this.item.end)[0]

        this.load()
    }

    beforeDestroy() {
        removeEventBus(window, 'calendar-close', this.cancel)
        removeEventBus(window, 'calendar-add-result', this.getAddCalendarId)
    }
}
